import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Heart, ChevronLeft, ChevronRight } from 'lucide-react';
import Header from './components/Header11';
import Footer from './components/Footer11';

const Template11Shop = () => {
    const navigate = useNavigate();
    const [activeFilter, setActiveFilter] = useState('All');
    const [sortBy, setSortBy] = useState('featured');
    const [currentPage, setCurrentPage] = useState(1);
    const [wishlist, setWishlist] = useState({});
    const [hoveredCard, setHoveredCard] = useState(null);

    const categories = ['All', 'Sherwanis', 'Kurta Pajamas', 'Nehru Jackets', 'Formal Suits', 'Accessories'];

    const sortOptions = [
        { value: 'featured', label: 'Featured' },
        { value: 'price-low', label: 'Price: Low to High' },
        { value: 'price-high', label: 'Price: High to Low' },
        { value: 'newest', label: 'Newest First' },
    ];

    const products = [
        { id: 1, name: 'Royal Black Sherwani', category: 'Sherwanis', price: 24999, badge: 'Bestseller', image: 'https://images.pexels.com/photos/2916387/pexels-photo-2916387.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 2, name: 'Ivory Silk Kurta Set', category: 'Kurta Pajamas', price: 5999, image: 'https://images.pexels.com/photos/3224610/pexels-photo-3224610.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 3, name: 'Charcoal Nehru Jacket', category: 'Nehru Jackets', price: 7499, badge: 'New', image: 'https://images.pexels.com/photos/2681751/pexels-photo-2681751.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 4, name: 'Navy Formal Suit', category: 'Formal Suits', price: 18999, image: 'https://images.pexels.com/photos/1536619/pexels-photo-1536619.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 5, name: 'Gold Brocade Sherwani', category: 'Sherwanis', price: 29999, badge: 'Premium', image: 'https://images.pexels.com/photos/3014853/pexels-photo-3014853.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 6, name: 'Sage Linen Kurta', category: 'Kurta Pajamas', price: 4499, image: 'https://images.pexels.com/photos/2955375/pexels-photo-2955375.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 7, name: 'Burgundy Bandhgala', category: 'Nehru Jackets', price: 12999, image: 'https://images.pexels.com/photos/4614070/pexels-photo-4614070.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 8, name: 'Classic Black Tuxedo', category: 'Formal Suits', price: 22999, badge: 'Limited', image: 'https://images.pexels.com/photos/6712360/pexels-photo-6712360.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 9, name: 'Maroon Velvet Sherwani', category: 'Sherwanis', price: 26999, image: 'https://images.pexels.com/photos/2916387/pexels-photo-2916387.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 10, name: 'White Cotton Kurta', category: 'Kurta Pajamas', price: 2999, image: 'https://images.pexels.com/photos/3224610/pexels-photo-3224610.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 11, name: 'Olive Green Jacket', category: 'Nehru Jackets', price: 8999, badge: 'New', image: 'https://images.pexels.com/photos/2681751/pexels-photo-2681751.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 12, name: 'Charcoal Slim Suit', category: 'Formal Suits', price: 15999, image: 'https://images.pexels.com/photos/1536619/pexels-photo-1536619.jpeg?auto=compress&cs=tinysrgb&w=400' },
    ];

    const filtered = activeFilter === 'All' ? products : products.filter(p => p.category === activeFilter);
    const sorted = [...filtered].sort((a, b) => {
        if (sortBy === 'price-low') return a.price - b.price;
        if (sortBy === 'price-high') return b.price - a.price;
        return 0;
    });

    const toggleWishlist = (e, id) => { e.stopPropagation(); setWishlist(prev => ({ ...prev, [id]: !prev[id] })); };

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Oswald:wght@400;500;600;700&family=Source+Sans+3:wght@300;400;600&display=swap');
            `}</style>

            <div style={{ fontFamily: "'Source Sans 3', -apple-system, sans-serif" }} className="min-h-screen" >
                <Header />

                {/* Hero Banner */}
                <div
                    className="pt-[100px] md:pt-[120px] pb-[50px] md:pb-[70px] px-6 text-center"
                    style={{ backgroundColor: '#1C1917', borderBottom: '1px solid #44403C' }}
                >
                    <div className="max-w-[800px] mx-auto">
                        <div className="w-10 h-0.5 mx-auto mb-4" style={{ backgroundColor: '#D97706' }} />
                        <p className="text-xs tracking-[0.3em] uppercase mb-3" style={{ color: '#D97706', fontFamily: "'Oswald', sans-serif", fontWeight: 500 }}>
                            The Collection
                        </p>
                        <h1
                            className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-wide mb-4"
                            style={{ fontFamily: "'Oswald', sans-serif", color: '#FAFAF9', textTransform: 'uppercase' }}
                        >
                            SHOP ALL
                        </h1>
                        <p className="text-sm" style={{ color: '#A8A29E' }}>
                            Premium Indian menswear crafted for the modern gentleman
                        </p>
                    </div>
                </div>

                {/* Filters & Sort */}
                <div style={{ backgroundColor: '#292524', borderBottom: '1px solid #44403C' }}>
                    <div className="max-w-[1400px] mx-auto px-4 sm:px-6 py-4">
                        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                            {/* Category Pills */}
                            <div className="flex flex-wrap gap-2">
                                {categories.map(cat => (
                                    <button
                                        key={cat}
                                        onClick={() => { setActiveFilter(cat); setCurrentPage(1); }}
                                        style={{
                                            padding: '8px 16px',
                                            fontSize: '12px',
                                            fontFamily: "'Oswald', sans-serif",
                                            fontWeight: 500,
                                            letterSpacing: '1px',
                                            textTransform: 'uppercase',
                                            cursor: 'pointer',
                                            border: `1px solid ${activeFilter === cat ? '#D97706' : '#44403C'}`,
                                            backgroundColor: activeFilter === cat ? '#D97706' : 'transparent',
                                            color: activeFilter === cat ? '#1C1917' : '#A8A29E',
                                            transition: 'all 0.3s ease',
                                        }}
                                    >
                                        {cat}
                                    </button>
                                ))}
                            </div>
                            {/* Sort */}
                            <select
                                value={sortBy}
                                onChange={(e) => setSortBy(e.target.value)}
                                style={{
                                    padding: '8px 16px',
                                    backgroundColor: '#1C1917',
                                    border: '1px solid #44403C',
                                    color: '#FAFAF9',
                                    fontSize: '13px',
                                    fontFamily: "'Source Sans 3', sans-serif",
                                    outline: 'none',
                                    cursor: 'pointer',
                                }}
                            >
                                {sortOptions.map(opt => (
                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>

                {/* Product Grid */}
                <div className="px-4 sm:px-6 py-12 sm:py-16" style={{ backgroundColor: '#1C1917' }}>
                    <div className="max-w-[1400px] mx-auto">
                        <p className="text-sm mb-6" style={{ color: '#A8A29E' }}>
                            Showing {sorted.length} {sorted.length === 1 ? 'product' : 'products'}
                        </p>
                        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6">
                            {sorted.map(product => (
                                <div
                                    key={product.id}
                                    onClick={() => navigate(`/template11/product/${product.id}`)}
                                    onMouseEnter={() => setHoveredCard(product.id)}
                                    onMouseLeave={() => setHoveredCard(null)}
                                    className="cursor-pointer overflow-hidden"
                                    style={{
                                        backgroundColor: '#292524',
                                        border: `1px solid ${hoveredCard === product.id ? '#D97706' : '#44403C'}`,
                                        transition: 'border-color 0.3s ease',
                                    }}
                                >
                                    <div className="relative overflow-hidden" style={{ aspectRatio: '3 / 4' }}>
                                        <img
                                            src={product.image}
                                            alt={product.name}
                                            className="w-full h-full object-cover transition-transform duration-500"
                                            style={{ transform: hoveredCard === product.id ? 'scale(1.05)' : 'scale(1)' }}
                                        />
                                        {product.badge && (
                                            <span
                                                className="absolute top-3 left-3 text-[10px] font-bold uppercase tracking-wider px-3 py-1"
                                                style={{ backgroundColor: '#D97706', color: '#1C1917' }}
                                            >
                                                {product.badge}
                                            </span>
                                        )}
                                        <button
                                            onClick={(e) => toggleWishlist(e, product.id)}
                                            className="absolute top-3 right-3 w-9 h-9 flex items-center justify-center backdrop-blur-sm"
                                            style={{ backgroundColor: 'rgba(28,25,23,0.6)', border: 'none', cursor: 'pointer' }}
                                        >
                                            <Heart size={18} style={{ color: wishlist[product.id] ? '#D97706' : '#FAFAF9', fill: wishlist[product.id] ? '#D97706' : 'none' }} />
                                        </button>
                                    </div>
                                    <div className="p-4">
                                        <p className="text-xs uppercase tracking-wider mb-1" style={{ color: '#A8A29E', fontFamily: "'Oswald', sans-serif" }}>{product.category}</p>
                                        <h3 className="text-sm font-semibold mb-2 truncate" style={{ color: '#FAFAF9' }}>{product.name}</h3>
                                        <span className="text-base font-semibold" style={{ color: '#D97706' }}>{`\u20B9${product.price.toLocaleString('en-IN')}`}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <Footer />
            </div>
        </>
    );
};

export default Template11Shop;
